module.exports = __webpack_public_path__ + "static/focus-img-f109fa14d8fd97ad6c172b7341b00fca.png";